import { measurementConstants } from "../../constants";
import { measurementService } from "../../services";
import { alertActions } from "../alert.actions";

export const measurementActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    measurementService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: measurementConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: measurementConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: measurementConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    measurementService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: measurementConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: measurementConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: measurementConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    measurementService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: measurementConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: measurementConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: measurementConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    measurementService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: measurementConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: measurementConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: measurementConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: measurementConstants.CLEAR };
}
